export const FLOW_PARENT_ENTITY = {
  ORGANIZATION: 'Organization',
  EVENT: 'Event',
} as const;

export type FlowParentEntity = (typeof FLOW_PARENT_ENTITY)[keyof typeof FLOW_PARENT_ENTITY];
